import { USER_DATA_TABLES } from "./schema";

/**
 * Generates a query to check if there is local data for a given user.
 */
export const getHasLocalDataQuery = (userId: string) => {
  const tableChecks = USER_DATA_TABLES.map(
    (table) => `      WHEN EXISTS (SELECT id FROM ${table} WHERE user_id = ? LIMIT 1) THEN 1`,
  ).join("\n");
  const params = Array.from({ length: USER_DATA_TABLES.length }).fill(userId);

  return {
    sql: `
    SELECT CASE 
      WHEN EXISTS (SELECT 1 FROM ps_crud LIMIT 1) THEN 1
${tableChecks}
      ELSE 0
    END as hasData
  `,
    parameters: params,
  };
};
